module.exports = __webpack_public_path__ + "static/Grey Siding and Black Roofing - Cladding-19fdeb92d53a32311182dfb83ca388de.jpg";